import React from 'react'

const PackUpIcon = () => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 9.5C8.11689 9.5 8.2221 9.46443 8.31561 9.39328L15.6448 1.92292C15.7149 1.85178 15.75 1.75692 15.75 1.63834C15.75 1.51976 15.7149 1.41304 15.6448 1.31818L14.9434 0.606719C14.8733 0.535573 14.7798 0.5 14.6629 0.5C14.546 0.5 14.4408 0.535573 14.3473 0.606719L8 7.04545L1.65271 0.606719C1.5592 0.535573 1.454 0.5 1.3371 0.5C1.22021 0.5 1.1267 0.535573 1.05656 0.606719L0.355204 1.31818C0.285068 1.41304 0.25 1.51976 0.25 1.63834C0.25 1.75692 0.285068 1.85178 0.355204 1.92292L7.71946 9.39328C7.78959 9.46443 7.88311 9.5 8 9.5Z"
      fill="#2C2C2C"
    />
  </svg>
)

export { PackUpIcon }
